import Vue from 'vue'
import vue from '../main'
import md5 from 'js-md5';

// 时间戳转时间 now：当前时间  type:1 年月日时分秒  else
function ZHDate(now, type) {
  let year = now.getFullYear();
  let month = now.getMonth() + 1;
  let date = now.getDate();
  let hour = now.getHours();
  let minute = now.getMinutes();
  let second = now.getSeconds();
  if (type === 1) {
    return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type === 2) {
    return getzf(hour) + ":" + getzf(minute)
  } else if (type === 6) {
    return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute) + ":" + getzf(second)
  } else if (type === 7) {
    return year + "-" + getzf(month) + "-" + getzf(date) + "  " + getzf(hour) + ":" + getzf(minute)
  } else if (type === 8) {
    return month + "月" + getzf(date) + '日'
  } else if (type === 9) {
    return year + "-" + getzf(month)
  } else {
    return year + "-" + getzf(month) + "-" + getzf(date)
  }
}

function getzf(num) {
  if (parseInt(num) < 10) {
    num = '0' + num;
  }
  return num;
}

// eslint-disable-next-line no-unused-vars
function getQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

//时间转为刚刚，几分钟前，几小时前，几天前
function setDate(dateTimeStamp) {  // dateTimeStamp 时间戳
  let minute = 1000 * 60
  let hour = minute * 60
  let day = hour * 24
  // let halfamonth = day * 15
  let month = day * 30

  if (dateTimeStamp == undefined) {

    return false
  } else {

    let sTime = dateTimeStamp

    let now = new Date().getTime()//获取当前时间的时间戳

    let diffValue = now - sTime

    if (diffValue < 0) {
      console.log("结束日期不能小于开始日期！")
    }

    let monthC = diffValue / month;
    let weekC = diffValue / (7 * day);
    let dayC = diffValue / day;
    let hourC = diffValue / hour;
    let minC = diffValue / minute;

    if (monthC >= 1) {
      return ZHDate(new Date(sTime * 1000))
    } else if (weekC >= 1) {
      return parseInt(weekC) + "周前"
    } else if (dayC >= 1) {
      return parseInt(dayC) + "天前"
    } else if (hourC >= 1) {
      return parseInt(hourC) + "个小时前"
    } else if (minC >= 1) {
      return parseInt(minC) + "分钟前"
    } else {
      return "刚刚"
    }
  }

}

function checkTel(tel) {   //验证手机号
  if (!(/^1[3456789]\d{9}$/.test(tel))) {
    return true
  } else {
    return false
  }
}

function checkCode(code) { //验证验证码
  if (code.toString().length === 6) {
    return false
  } else {
    return true
  }
}

function showToast(txt) {
  let toast = vue.$createToast({
    txt: txt,
    type: 'txt'
  })
  toast.show()
}


// 状态码说明：
// 200:统一正确码（不会有null值）|


const tools = {
  ZHDate, // 时间戳转转化时间
  setDate, //  时间戳转 刚刚 一天前
  checkTel, //  验证手机号
  checkCode,  //  验证验证码
  showToast,
}


Vue.prototype.$md5 = md5;
Vue.prototype.$tools = tools;


export const edit_files = [
  {
    types:['doc', 'dot', 'wps', 'wpt', 'docx', 'dotx', 'docm', 'dotm'],
    officeType:'Writer'
  },
  {
    types:['xls', 'xlt', 'et', 'xlsx', 'xltx', 'xlsm', 'xltm', 'ett'],
    officeType:'Spreadsheet'
  },
  {
    types:['ppt', 'pptx', 'pptm', 'ppsx', 'ppsm', 'pps', 'potx', 'potm', 'dpt', 'dps', 'pot'],
    officeType:'Presentation'
  },
  {
    types:['pdf', 'ofd'],
    officeType:'Pdf'
  },
  {
    types:['otl'],
    officeType:'Otl'
  },
  {
    types:['pdf'],
    officeType:'Dbt'
  },
]